<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-2cadd23a35244d829ddf0021c30a46b5')>-1"
          >添加租户</el-button
        >
        <el-button
          type="info"
          @click="deleteSignAll(theCheckObj.corpCode)"
          plain
          v-if="userRoleList.indexOf('menu-2cadd23a35244d829ddf0021c30a46b5')>-1"
          >删除</el-button
        >
        <span class="searchInputText">租户名称</span>
        <el-input placeholder="请输入租户名称" v-model="search.name"></el-input>
        <!-- <span class="searchInputText">角色</span>
        <el-input placeholder="请输入角色" v-model="search.roleName"></el-input>
        <span class="searchInputText">所属组织</span>
        <el-input
          placeholder="请输入所属组织"
          v-model="search.officeName"
        ></el-input> -->
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="corpName"
              label="租户名"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="组织（公司）名"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="contact"
              label="组织负责人"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="负责人电话"
              width="150"
            ></el-table-column>
            <!-- <el-table-column
              prop="viewCode"
              label="组织代码"
              width="120"
            ></el-table-column> -->
            <!-- <el-table-column
              prop="createDate"
              label="创建时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="updateDate"
              label="更新时间"
              width="180"
            ></el-table-column> -->
            <el-table-column
              prop="adminAccount"
              label="管理员账号"
              width="190"
            ></el-table-column>
            <el-table-column
              prop="workerAccount"
              label="施工员账号"
              width="190"
            ></el-table-column>
            <el-table-column
              prop=""
              label="状态"
              width="50"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 0">正常</span>
                    <span v-if="scope.row.status == 1">删除</span>
                    <span v-if="scope.row.status == 2">停用</span>
                    <span v-if="scope.row.status == 3">冻结</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="">
              <template slot-scope="scope">
                <span class="lookMore" @click="openModbox(scope.row)" v-if="userRoleList.indexOf('menu-2cadd23a35244d829ddf0021c30a46b5')>-1">修改</span>
                <span class="lookMore" @click="freezeDo(scope.row)" v-if="userRoleList.indexOf('menu-2cadd23a35244d829ddf0021c30a46b5')>-1 && scope.row.status!=3">冻结</span>
                <span class="lookMore" @click="freezeDo(scope.row)" v-if="userRoleList.indexOf('menu-2cadd23a35244d829ddf0021c30a46b5')>-1 && scope.row.status==3">取消冻结</span>
                <span
                  class="lookMore"
                   @click="resetPassFun(scope.row,1)"
                  >重置管理员密码</span>
                <span
                  class="lookMore"
                   @click="resetPassFun(scope.row,2)"
                  >重置施工员密码</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="租户名" required prop="corpName">
            <el-input
              class="longType"
              v-model="modelObj.corpName"
              maxlength="20"
              placeholder="请输入租户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="组织（公司）名" required prop="companyName">
            <el-input
              class="shotType"
              v-model="modelObj.companyName"
              maxlength="30"
              placeholder="请输入组织（公司）名"
            ></el-input>
          </el-form-item>

          <el-form-item label="组织负责人">
            <el-input
              class="shotType"
              v-model="modelObj.contact"
              maxlength="20"
              placeholder="请输入组织负责人"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人电话">
            <el-input
              class="shotType"
              v-model="modelObj.phone"
              maxlength="11"
              placeholder="请输入负责人电话"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="管理员账号" required prop="adminAccount" v-if="actionName != '修改'">
            <el-input
              class="shotType"
              v-model="modelObj.adminAccount"
              maxlength="30"
              placeholder="请输入管理员账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="施工员账号" required prop="workerAccount" v-if="actionName != '修改'">
            <el-input
              class="shotType"
              v-model="modelObj.workerAccount"
              maxlength="30"
              placeholder="请输入施工员账号"
            ></el-input>
          </el-form-item>
          <div style="clear: both"></div>
        </el-form>
        
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="addModSubmit">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="actionNameN"
      :visible.sync="officeShow"
      :close-on-click-modal="false"
      width="400px"
      @selection-change="handleSelectionChange"
      :row-key="fieldKey"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree
          :data="treeList"
          node-key="id"
          ref="maskTree"
          default-expand-all
          accordion
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"
        ></el-tree>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchDeptList,
  fetchCorpList,
  getRoleList,
  editCorp as modPut,
  addCorp as addPost,
  delCorp as delPut,
  resetPassWord,
  freezeCorp
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "corpCodes",
      fieldRowName: "name",
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      arrowList: [
        {
          name: "租户管理",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      search: {},
      modelObj: {},
      actionName: "",
      treeList: [],
      dataList: [],
      activeObj: "",
      theCheckObj: "",
      officeShow: false,
      checkedKeys: [],
      actionNameN: '',
      roleValue: '',
      restaurants: '',
      userRoleList: localStorage.getItem("userRoleList")
    };
  },
  computed: {
    rules: function () {
      return {
        corpName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        companyName: [{ required: true, message: "必填" }],
        adminAccount: [{ required: true, message: "必填" }, { trigger: "blur" }],
        workerAccount: [{ required: true, message: "必填" }, { trigger: "blur" }]
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getDataList();
    // this.getDeptList()
  },
  methods: {
    addPost,
    modPut,
    delPut,
    openOffice: function () {
      console.log("111");
      this.actionNameN = "部门选择";
      this.officeShow = true;
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    getDeptList: function () {
      fetchDeptList({}).then((res) => {
        console.log(res);
        let _arr = res.data.content.concat([]);

        let _getDepts = function(list, _depts) {
          for (let i = 0; i < list.length; i++) {
            let _m = list[i];
            _depts.push({
              id: _m.officeCode,
              label: _m.officeName,
              originalData: _m
            });

            if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
              _depts[_depts.length - 1].children = [];
              _getDepts(_m.children, _depts[_depts.length - 1].children);
            }
          }
        };
        let _depts = [];
        _getDepts(_arr, _depts);
        this.treeList = _depts;
      });
      getRoleList({}).then(res => {
        var postList = res.data.content.list
        for(var i=0;i<postList.length;i++){
            postList[i].value = postList[i].roleName
            postList[i].id = postList[i].roleCode
            
        }
        this.restaurants = postList
      })
    },
    getDataList: function (params) {
      fetchCorpList(params).then((res) => {
        console.log(res);
        // let _arr = res.data.content.list.concat([]);

        // let _getDepts = function(list, _depts) {
        //   for (let i = 0; i < list.length; i++) {
        //     let _m = list[i];
        //     _depts.push({
        //       id: _m.officeCode,
        //       label: _m.officeName,
        //       originalData: _m
        //     });

        //     if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
        //       _depts[_depts.length - 1].children = [];
        //       _getDepts(_m.children, _depts[_depts.length - 1].children);
        //     }
        //   }
        // };
        // let _depts = [];
        // _getDepts(_arr, _depts);
        // this.treeList = _depts;
        this.pageMsg = this.pageAssign(res.data.content);
        this.dataList = res.data.content.list;
      });
    },
    handleNodeClickAdd(val){
        console.log(val)
        this.modelObj.officeName = val.label
        this.modelObj.officeCode = val.id
        this.officeShow = false
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.theCheckObj = selection[0];
      if (selection.length == 0) {
        this.checkedGh = "";
      } else {
        this.checkedGh = selection[0].id;
        this.checkedName = selection[0].sectionName;
        if (selection.length > 1) {
          this.$refs.tb.clearSelection();
          this.$refs.tb.toggleRowSelection(selection.pop());
        }
      }
    },
    roleChange: function(e){
        console.log(e)
        var roleCodeList = []
        var getList = this.restaurants
        for(var i=0;i<e.length;i++){
            for(var j=0;j<getList.length;j++){
                if(e[i] == getList[j].roleName){
                    roleCodeList.push(getList[j].roleCode)
                }
            }
        }
        console.log(roleCodeList)
        this.modelObj.roleCode = roleCodeList.join(",")
        this.modelObj.roleName = e.join(",")
    },
    freezeDo(rowV){
        let statusV = rowV.status
        let str = ''
        let backStr = ''
        let statusSet = 0
        if(statusV == 3){
            str = '确认对'+rowV.corpName+'进行取消冻结吗？'
            statusSet = 0
            backStr = '取消冻结'
        }else{
            str = '确认对'+rowV.corpName+'进行冻结吗？'
            statusSet = 1
            backStr = '冻结'
        }
        this.$confirm(
          str,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          let params={};
          params.corpCode = rowV.corpCode
          params.status = statusSet
          freezeCorp(params).then((res) => {
            console.log(res)
            this.showToast(res.data.code,res.data.message,backStr)
            this.doSearch(this.lastQuery);
          });
        });
    },
    resetPassFun(data,type){
        let params = {}
        let str = ''
        if(type == 1){
            params = {
                userCode: data.adminUserCode
            }
            str = '管理员'
        }else{
            params = {
                userCode: data.workerUserCode
            }
            str = '施工员'
        }
        this.$confirm(
          '确认对'+data.corpName+'的'+str+'进行密码重置吗?' + "<br/>",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          resetPassWord(params).then((res) => {
            //console.log(res)
            if(res.data.code == 200){
              this.$message({
                message: "操作成功!",
                type: "success"
              });
              this.doSearch(this.lastQuery);
            }
            
          });
        });
        
    }
    
  },
  components: {
    ElPageCover,
  },
};
</script>

<style lang="scss">
// .addAndEdit {
//   .el-input {
//     width: 180px !important;
//     height: 36px !important;
//     margin-left: 23px;
//     margin-right: 23px;
//     font-size: 14px !important;
//     .el-input__inner {
//       width: 180px !important;
//       height: 36px !important;
//       border-radius: 1px !important;
//     }
//   }
// }
.el-dialog{
    .el-form-item{
        height: 40px !important;
    }
}

</style>
<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>